import './MiniOverlay.css';
import {useAsset} from "../../AssetHelper";
import ScrollingText from "../components/ScrollingText";
import {DisplayConfig} from "../Config";
import { ReactNode, useContext } from "react";
import DisplayParams from "../DisplayParams";
import {ReactSVG} from "react-svg";
import {t} from "../../i18n";
import EventName from "../components/EventName";

export default function MiniOverlay({children, config, header, collapse, type} : {
    children: ReactNode,
    config: DisplayConfig,
    header: string,
    collapse?: boolean,
    type: 'advancement' | 'award'
}) {
    const displayParams = useContext(DisplayParams)
    const gameLogo = useAsset(`img/logos/decode_season_primary_wide${displayParams.alternatePresentingSponsor ? '_' + displayParams.alternatePresentingSponsor : ''}.svg`)
    const themeLogo = useAsset(displayParams.isFirstChampionship ? "img/logos/decode_fcmp_onecolor.svg" : "img/logos/decode_season_global_wide.svg")
    const programLogo = useAsset("img/logos/ftc_horiz_reverse.svg")
    const name = <ScrollingText className="eventName"><EventName invertLogo /></ScrollingText>;

    return <div className="h-100 w-100 miniOverlayContainer" style={{ background: config.overlayColor }}>
        <div className={"miniOverlayHeader"}>
            {themeLogo ? <div className={"themeLogoWrapper"}>
                <img className="themeLogo" src={themeLogo} />
            </div> : null}
            <div className={"eventNameContainer"}>
                <ScrollingText className="eventName">{name}</ScrollingText>
            </div>
            {gameLogo ? <div className={"gameLogoWrapper"}>
                <img className="gameLogo" src={gameLogo} />
            </div> : null}
        </div>
        <div className={`miniOverlay ${type} ${children && !collapse ? "" : "shrunk"}`}>
            <div className="topAreaWrapper">
                <div className={"topAreaContainer"}>
                <div className="topBar">
                    {programLogo ? <div className={"programLogoWrapper"}>
                          <img className="programLogo" src={programLogo}/>
                    </div> : null }
                    <div className={"overlayHeaderContainer"}>
                        <ScrollingText className="overlayHeader" width={"1200px"}><span dangerouslySetInnerHTML={{__html: header}}></span></ScrollingText>
                    </div>
                    </div>
                    <div className={"miniOverlayContainer"}>
                        {children}
                    </div>
                </div>
            </div>
        </div>
    </div>
}